import { configureStore, createListenerMiddleware, isRejected } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'

import { app_api } from './app_api/_api'
import { auth_api } from './auth_api/_api'
import authSlice from './slice/auth'
import settingsSlice from './slice/settings'
import companySlice from './slice/company'

import createIntlMiddleware from '../admincore/localization/IntlReduxMiddleware'
import networkSaga from '../admincore/redux/network/sagas'
import modules from '../modules'

const listenerMiddleware = createListenerMiddleware({
  // extra: 'createListenerMiddleware extra: extra_argument',
  // onError: (error, errorInfo) => console.log('createListenerMiddleware onError: ', error, errorInfo),
})

listenerMiddleware.startListening({
  predicate: (action /* , currentState, previousState */) => {
    if (isRejected(action) && action?.payload?.status === 401) {
      // console.log('startListening predicate 401: ', action, currentState, previousState);
      return true
    }

    return false
  },
  effect: (action, listenerApi) => {
    // console.log('startListening effect: ', action, listenerApi);
    listenerApi.dispatch(authSlice.actions.logout({ isError: true, error: '401 - Unauthorized' }))
  },
})

const processModules = (moduless = []) => {
  // Ensure module name uniqueness
  const names = moduless.map(m => m.name)

  const duplicates = names.filter((item, index) => names.indexOf(item) !== index)

  if (duplicates.length > 0) {
    // Remove triple or more from "duplicates"
    const duplicatesSet = new Set(duplicates)
    throw new Error(`Modules' names are not unique! Duplicates: ${JSON.stringify(Array.from(duplicatesSet))}`)
  }

  return moduless
}

const getReducersAndSagas = moduless => {
  let reducers = {}
  let sagas = []

  moduless.forEach(module => {
    if (module.reducers) {
      reducers = {
        ...reducers,
        ...module.reducers,
      }
    }

    if (module.sagas) {
      sagas = [...sagas, ...module.sagas]
    }
  })

  return [reducers, sagas]
}

function* entry_rootSaga(sagas) {
  yield sagas.forEach(s => {
    if (typeof s !== 'function') {
      throw new Error('entry_rootSaga: saga is not a function')
    }
  })

  yield all(sagas.map(s => s()))
}

let ReduxStore = null

const createReduxStore = () => {
  const sagaMiddleware = createSagaMiddleware({
    // sagaMonitor
  })

  const intlMiddleware = createIntlMiddleware()

  const processedModules = processModules(modules)
  const [reducers, sagas] = getReducersAndSagas(processedModules)

  ReduxStore = configureStore({
    reducer: {
      [app_api.reducerPath]: app_api.reducer,
      [auth_api.reducerPath]: auth_api.reducer,
      [authSlice.name]: authSlice.reducer,
      [settingsSlice.name]: settingsSlice.reducer,
      [companySlice.name]: companySlice.reducer,
      ...reducers,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware()
        .prepend(listenerMiddleware.middleware)
        .concat(intlMiddleware)
        .concat(sagaMiddleware)
        .concat(app_api.middleware)
        .concat(auth_api.middleware),
  })

  sagaMiddleware.run(entry_rootSaga, [networkSaga, ...sagas])

  return ReduxStore
}

export default createReduxStore
